import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { memo, useState } from "react";

export const ConfirmDeleteFolderModal = memo(function ConfirmDeleteFolderModal({
  isOpen,
  onClose,
  onConfirm,
  folderName,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  folderName: string;
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      await onConfirm();
      onClose();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <RedoModal
      isOpen={isOpen}
      modalSize="sm"
      onModalCloseRequested={isSubmitting ? () => {} : onClose}
      primaryButton={{
        text: "Delete",
        onClick: handleConfirm,
        disabled: isSubmitting,
        theme: "destructive",
        size: "sm",
      }}
      secondaryButton={{
        text: "Cancel",
        onClick: onClose,
        disabled: isSubmitting,
        size: "sm",
      }}
      subtitle={`Are you sure you want to delete the folder "${folderName}"?`}
      title="Delete folder"
    />
  );
});
